<template>
  <div>
    <div class="certif-list">
      <div class='img-div' v-for="item in images" :key="item.ID">
          <img :src="`${ApiService.ImgHost}/${item.PicPath}_200x126.png`" class="imgItem">
      </div>
      <div class="img-div2" v-for="(item, index) in 10" :key="index"></div>
    </div>
    <el-empty description="暂无数据" v-if="images.length <= 0"></el-empty>
    <div class="pagination">
      <md-page class="prod-page" :small="true" :page="page" :total="total" :pageSize="pageSize" @pagecallback="pageChanged"></md-page>
    </div>
  </div>
</template>

<script>
import { CompService, ApiService } from '/@/service'

export default {
  data() {
    return {
      images: [],
      page: 1,
      total: 0,
      pageSize: 15,

      ApiService
    }
  },
  mounted() {
    this.getCompPicList();
  },
  methods: {
    async getCompPicList() {
      const res = await CompService.getCompPicList(this.$route.params.id, this.page, this.pageSize);
      if (res) {
        this.images = res.List || [];
        this.total = res.TotalCount || 0;
      }
    },
    pageChanged(param) {
      this.page = param.page;
      this.getCompPicList();
    },
  }
}
</script>

<style lang="less" scoped>
.certif-list{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.img-div2{
  width: 200px;
  height: 1px;
  margin-bottom: 12px;
}
.img-div{
  width: 200px;
  height: 126px;
  background: #FFFFFF;
  padding: 6px;
  box-shadow: 0px 2px 4px 0px rgba(158, 173, 191, 0.39);
  margin-bottom: 12px;
}
.img-block{
  width: 200px;
  height: 126px;
  margin-bottom: 12px;
}
</style>
